import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  changesFailed: {
    description: 'Error message title',
    defaultMessage: 'API keys failed to regenerate.',
    id: 'dY4xsD',
  },
  generateFailTitle: {
    description: 'Error message title',
    defaultMessage: 'API keys failed to generate.',
    id: 'otlv2T',
  },
  generateFailMessage: {
    description: 'Generic error message content when regenerating',
    defaultMessage: 'Unable to generate an API Key, please try again later.',
    id: 'tuj0ev',
  },
  successTitle: {
    description: 'Success notification title',
    defaultMessage: 'Success!',
    id: 'Znyu43',
  },
  generateSuccessMessage: {
    description: 'Success message',
    defaultMessage: "We've successfully generated your API key.",
    id: '4aEc8r',
  },
  generateErrorTitle: {
    description: 'Error title when trying to create an API Key',
    defaultMessage: 'Unable to Generate {isSandboxKey, select, true {Sandbox} other {Production}} Key',
    id: 'F/3Q2U',
  },
  generateErrorMessage: {
    description: 'Error message when trying to create an API Key',
    defaultMessage:
      'We could not generate your {isSandboxKey, select, true {sandbox} other {production}} key. Refresh the page and try again. If the issue persists, contact our API support.',
    id: 'NClDwz',
  },
  deleteSuccessMessage: {
    description: 'Success notification title',
    defaultMessage: '{isSandboxKey, select, true {Sandbox} other {Production}} Token has been successfully deleted.',
    id: 'zJpaxR',
  },
  deleteSuccessMessageV1: {
    description: 'Success notification title when removing V1 API Key',
    defaultMessage: 'The API Key has been successfully deleted.',
    id: 'R+xqqp',
  },
  deleteErrorTitleV1: {
    description: 'Error message title when deleting V1 API Key',
    defaultMessage: 'An error occurred while deleting the API Key.',
    id: 'bcZPlZ',
  },
  deleteErrorMessageV1: {
    description: 'Error message content',
    defaultMessage: 'We could not delete your API Key. Refresh the page and try again. If the issue persists, contact our API support.',
    id: 'zCpsGi',
  },
  deleteErrorTitle: {
    description: 'Error message title',
    defaultMessage: 'Unable to delete {isSandboxKey, select, true {Sandbox} other {Production}} Key',
    id: '8kDoWO',
  },
  deleteErrorMessage: {
    description: 'Error message content',
    defaultMessage:
      'We could not delete your {isSandboxKey, select, true {sandbox} other {production}} key. Refresh the page and try again. If the issue persists, contact our API support.',
    id: 'p9U5ro',
  },
});
